export function camelCase(string: string) {
	return string
		.split(" ")
		.map((word, index) => {
			if (index === 0) {
				return word.toLowerCase();
			}
			return word[0].toUpperCase() + word.slice(1).toLowerCase();
		})
		.join("");
}

/**
 * Format human-readable filesize from an integer of bytes
 */
export function formatBytes(
	bytes: number,
	decimals = 2,
	renderFn = (n: number, unit: string) => n + " " + unit,
) {
	const k = 1024,
		sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
		i = Math.floor(Math.log(bytes) / Math.log(k));

	const n = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
	const unit = sizes[i];

	return renderFn(n, unit);
}

export function kebabCase(id: string) {
	return id
        .trim()
        .toLowerCase()
		.replace(/[^a-zA-Z-_0-9\s]/g, "")
		.replace(/[\s_-]/g, "-")
		.replace(/-+/g, "-");
}
